export const environment = {
  production: true,
  baseUrl: 'https://glap-dev.glp-dev.aws.pmicloud.biz/api/',
  notification: 'https://glap-dev.glp-dev.aws.pmicloud.biz/notificationsHub',
  msalConfig: {
    auth: {
      clientId: '1b3a16f3-a610-4ede-857a-0d25489d8c31',
      authority: 'https://login.microsoftonline.com/8b86a65e-3c3a-4406-8ac3-19a6b5cc52bc',
      redirectUri: 'https://glap-dev.glp-dev.aws.pmicloud.biz/',
    }
  },
  apiConfig: {
    scopes: ['openid', 'User.Read','Group.Read.All', 'GroupMember.Read.All'  ],
    uri: 'https://graph.microsoft.com/v1.0/'
  }
};

